var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharmSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07086 0.200684C2.73064 0.200684 0 2.93132 0 6.27154C0 9.61177 2.73064 12.3424 6.07086 12.3424C7.35701 12.3424 8.55188 11.9379 9.53589 11.2488L13.1684 14.8868C13.5869 15.3053 14.2676 15.3053 14.6861 14.8868C15.1046 14.4683 15.1046 13.7876 14.6861 13.3691L11.0481 9.73658C11.7372 8.75244 12.1417 7.55767 12.1417 6.27154C12.1417 2.93132 9.41109 0.200684 6.07086 0.200684V0.200684ZM6.07086 2.34334C8.25334 2.34334 9.99907 4.08912 9.99907 6.27154C9.99907 8.45397 8.25328 10.1997 6.07086 10.1997C3.88844 10.1997 2.14266 8.45397 2.14266 6.27154C2.14266 4.08912 3.88844 2.34334 6.07086 2.34334Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharmSearch);
export default __webpack_public_path__ + "static/media/charm_search.ef923ff2c7f9dbe38b954d4bf9484b50.svg";
export { ForwardRef as ReactComponent };